import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { default as Actions } from '../actions';
import * as CommonActions from '../../common/actions';

import { BrandBand } from '../../common/components';
import {
  Header,
  McMenu,
  SelectionDetails,
  SubscriberDetails
} from '../components/';
import { Card } from '@salesforce/design-system-react';

import './SelectionDetailsDashboard.scss';

export class SelectionDetailsDashboard extends Component {
  componentDidMount() {
    this.props.actions.getAttributes();
    if (!this.props.assets.data.search.selectionDetails?.assets?.length) {
      this.props.actions.searchAssets(
        { ignore_children: true },
        {},
        { context: 'selectionDetails' }
      );
    }

    const { subscriber, jobId, blockId } = this.props.match.params;
    const current = { ...(this.props.selections.data.view || {}) };
    if (
      current.subscriber !== subscriber ||
      current.jobId !== jobId ||
      current.blockId !== blockId
    ) {
      this.props.actions.getSelections(subscriber, {
        locale: this.props.intl.locale
      });
      this.props.actions.viewSelection(subscriber, jobId, blockId);
    }
  }

  render() {
    const data = { ...(this.props.selections.data.view || {}) };
    const { selections, subscriber } = this.props.selections.data;
    let job, block;
    if (subscriber === data.subscriber && selections) {
      job = selections.jobs?.find(j => data.jobId === j.send.job_id);

      if (job) {
        block = job.blocks?.find(b => data.blockId === b.block_id);
      }
    }
    const assets = this.props.assets.data.search.selectionDetails?.assets || [];
    return (
      <McMenu
        flags={this.props.flags}
        history={this.props.history}
        route="/analytics/selections"
      >
        <BrandBand>
          <Header route={this.props.match} />
          <div className="selection-details-dashboard">
            <Card hasNoHeader>
              <SubscriberDetails
                job={job}
                block={block}
                subscriber={subscriber}
              />
            </Card>
            <Card hasNoHeader>
              <SelectionDetails
                actions={this.props.actions}
                assets={assets}
                attributes={this.props.attributes.data.assetAttributes}
                assetFilter={this.props.assets.data.browsedFilter}
                selections={this.props.selections}
                job={job}
                block={block}
                subscriber={subscriber}
              />
            </Card>
          </div>
        </BrandBand>
      </McMenu>
    );
  }
}

SelectionDetailsDashboard.contextTypes = {
  router: PropTypes.object
};

SelectionDetailsDashboard.propTypes = {
  actions: PropTypes.object,
  flags: PropTypes.object,
  location: PropTypes.object
};

function mapStateToProps(state) {
  return {
    assets: state.ecs.assets,
    attributes: state.ecs.attributes,
    flags: state.ecs.flags,
    selections: state.ecs.selections
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...Actions, ...CommonActions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(SelectionDetailsDashboard));
